import { Tab } from '@headlessui/react';
import React from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { Card } from '../../../designs-v2/components/card';
import { Icon } from '../../../designs-v2/primitives/icons';
import { UserTable } from './user-table';

const IconDisplays = () => {
  return (
    <div className="flex flex-row gap-5 text-preset-1 text-content-muted">
      <div className="flex flex-row gap-1 items-center">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.69614 4.04782C6.72452 4.34918 5.70092 4.66667 4.66663 4.66667C3.98183 4.66667 3.36959 4.5939 2.85272 4.49459C2.50084 4.42698 2.2664 4.38222 2.09755 4.3599C2.06428 4.3555 2.03673 4.35243 2.0141 4.35034C2.01265 4.36501 2.01119 4.38227 2.00985 4.40239C2.00032 4.54589 1.99996 4.74656 1.99996 5.05924L1.99996 12.2248C1.99996 12.2496 1.99999 12.2655 2.00016 12.2779C2.00164 12.2802 2.00317 12.2826 2.00474 12.285C2.0063 12.2874 2.00785 12.2898 2.00938 12.292C2.35689 12.4393 3.14183 12.6667 4.66663 12.6667C5.89132 12.6667 6.97439 12.3616 8.05391 12.0295C8.1368 12.004 8.2201 11.9781 8.30379 11.9522C9.27541 11.6508 10.299 11.3333 11.3333 11.3333C12.0181 11.3333 12.6303 11.4061 13.1472 11.5054C13.4991 11.573 13.7335 11.6178 13.9024 11.6401C13.9356 11.6445 13.9632 11.6476 13.9858 11.6497C13.9873 11.635 13.9887 11.6177 13.9901 11.5976C13.9996 11.4541 14 11.2534 14 10.9408V3.77516C14 3.75038 13.9999 3.73449 13.9998 3.7221C13.9983 3.71977 13.9968 3.71739 13.9952 3.71498C13.9936 3.71259 13.9921 3.71024 13.9905 3.70796C13.643 3.5607 12.8581 3.33333 11.3333 3.33333C10.1086 3.33333 9.02554 3.63836 7.94602 3.97052C7.86313 3.99602 7.77982 4.02186 7.69614 4.04782ZM14.0648 11.6535C14.0663 11.6534 14.0671 11.6533 14.0673 11.6534ZM1.93516 4.34646C1.93351 4.34662 1.93264 4.34666 1.93262 4.34664ZM7.55391 2.69615C8.64105 2.36164 9.89132 2 11.3333 2C13.0303 2 14.0106 2.25927 14.5571 2.50033C14.5587 2.50103 14.5604 2.5018 14.5624 2.50264C14.5912 2.5153 14.6575 2.54432 14.7302 2.59203C14.8043 2.64067 14.8662 2.69548 14.9205 2.7473C15.0045 2.82743 15.0747 2.92936 15.1122 2.98687C15.1496 3.04438 15.2146 3.14976 15.254 3.25892C15.3334 3.47871 15.3333 3.63477 15.3333 3.7662L15.3333 10.9633C15.3333 11.2469 15.3333 11.4927 15.3205 11.686C15.3085 11.8664 15.2815 12.1187 15.1516 12.3412C15.0809 12.4624 14.9887 12.5904 14.8533 12.7022C14.718 12.814 14.5749 12.8804 14.4426 12.927C14.1901 13.0158 13.914 12.9866 13.7276 12.9619C13.5153 12.9339 13.242 12.8813 12.9166 12.8188L12.8956 12.8148C12.4514 12.7294 11.9239 12.6667 11.3333 12.6667C10.5102 12.6667 9.67607 12.9242 8.64905 13.2412C8.58221 13.2619 8.51455 13.2828 8.44602 13.3039C7.35887 13.6384 6.10861 14 4.66663 14C2.9696 14 1.98932 13.7407 1.44283 13.4997C1.44125 13.499 1.4395 13.4982 1.43758 13.4974C1.40868 13.4847 1.34246 13.4557 1.26975 13.408C1.19563 13.3593 1.13372 13.3045 1.07943 13.2527C0.995466 13.1726 0.925252 13.0706 0.887766 13.0131C0.850281 12.9556 0.785351 12.8502 0.745923 12.7411C0.666537 12.5213 0.666586 12.3652 0.666628 12.2338L0.666629 5.03671C0.666621 4.75306 0.666613 4.50726 0.679453 4.314C0.691439 4.1336 0.718471 3.88135 0.848334 3.65878C0.919031 3.53762 1.01126 3.40959 1.14659 3.29779C1.28192 3.18599 1.42505 3.11957 1.55738 3.07301C1.80986 2.98416 2.08596 3.01343 2.27228 3.03806C2.48465 3.06614 2.75793 3.11865 3.08333 3.18118L3.10431 3.18521C3.54849 3.27055 4.07607 3.33333 4.66663 3.33333C5.48968 3.33333 6.32385 3.07581 7.35087 2.75876C7.41772 2.73812 7.48538 2.71723 7.55391 2.69615ZM12 5.33333C12.3682 5.33333 12.6666 5.63181 12.6666 6V8.66667C12.6666 9.03486 12.3682 9.33333 12 9.33333C11.6318 9.33333 11.3333 9.03486 11.3333 8.66667V6C11.3333 5.63181 11.6318 5.33333 12 5.33333ZM7.99996 7C7.44768 7 6.99996 7.44771 6.99996 8C6.99996 8.55228 7.44768 9 7.99996 9C8.55225 9 8.99996 8.55228 8.99996 8C8.99996 7.44771 8.55225 7 7.99996 7ZM5.66663 8C5.66663 6.71133 6.7113 5.66667 7.99996 5.66667C9.28863 5.66667 10.3333 6.71133 10.3333 8C10.3333 9.28866 9.28863 10.3333 7.99996 10.3333C6.7113 10.3333 5.66663 9.28866 5.66663 8ZM3.99996 6.66667C4.36815 6.66667 4.66663 6.96514 4.66663 7.33333V10C4.66663 10.3682 4.36815 10.6667 3.99996 10.6667C3.63177 10.6667 3.3333 10.3682 3.3333 10V7.33333C3.3333 6.96514 3.63177 6.66667 3.99996 6.66667Z"
            fill="#64748B"
          />
        </svg>
        High Deposit Amount
      </div>
      <div className="flex flex-row gap-1 items-center">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <g clip-path="url(#clip0_2726_1566)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M8.55376 0.687113C8.56606 0.688278 8.57696 0.689309 8.58628 0.690056C9.34856 0.75117 10.0978 0.931248 10.8066 1.22482C11.6963 1.59335 12.5047 2.13352 13.1857 2.81448C13.8666 3.49545 14.4068 4.30387 14.7753 5.19359C15.0689 5.90233 15.249 6.6516 15.3101 7.41389C15.3109 7.42321 15.3119 7.4341 15.313 7.44641C15.3246 7.56797 15.3491 7.82747 15.2422 8.07001C15.154 8.26992 14.9946 8.44263 14.8024 8.54646C14.6557 8.62569 14.5149 8.64956 14.411 8.65891C14.3246 8.66669 14.2276 8.66664 14.1494 8.66661C14.144 8.6666 14.1387 8.6666 14.1336 8.6666H8.53356C8.52849 8.6666 8.52335 8.6666 8.51814 8.66661C8.43873 8.66664 8.34389 8.66667 8.26034 8.65985C8.16353 8.65194 8.02487 8.63164 7.87957 8.55761C7.69141 8.46174 7.53843 8.30876 7.44255 8.12059C7.36852 7.97529 7.34823 7.83663 7.34032 7.73982C7.33349 7.65627 7.33353 7.56143 7.33356 7.48202C7.33356 7.47681 7.33356 7.47167 7.33356 7.4666V1.8666C7.33356 1.86142 7.33356 1.85614 7.33356 1.85076C7.33352 1.77256 7.33347 1.67556 7.34126 1.58913C7.35061 1.48531 7.37447 1.34445 7.45371 1.19776C7.55754 1.00553 7.73024 0.846119 7.93015 0.757983C8.1727 0.651052 8.43219 0.675609 8.55376 0.687113ZM8.66689 2.03709V7.33327H13.9631C13.9006 6.77421 13.7596 6.2256 13.5435 5.70383C13.242 4.97588 12.8 4.31445 12.2429 3.75729C11.6857 3.20014 11.0243 2.75819 10.2963 2.45666C9.77457 2.24054 9.22595 2.09959 8.66689 2.03709ZM5.94458 1.61996C6.09184 1.95742 5.93766 2.35036 5.6002 2.49762C4.70193 2.88961 3.91336 3.49568 3.30343 4.26284C2.6935 5.03 2.28078 5.93489 2.10136 6.8984C1.92194 7.86192 1.98127 8.85471 2.27418 9.78999C2.56709 10.7253 3.08465 11.5746 3.78161 12.2636C4.47858 12.9527 5.33372 13.4605 6.27229 13.7427C7.21086 14.0249 8.20426 14.0729 9.16566 13.8825C10.1271 13.6921 11.0272 13.2691 11.7873 12.6504C12.5475 12.0318 13.1445 11.2363 13.5262 10.3336C13.6696 9.99451 14.0608 9.83584 14.3999 9.97924C14.739 10.1226 14.8977 10.5138 14.7543 10.8529C14.2877 11.9562 13.558 12.9284 12.629 13.6845C11.6999 14.4407 10.5998 14.9577 9.42471 15.1904C8.24966 15.4231 7.0355 15.3645 5.88836 15.0196C4.74123 14.6746 3.69605 14.054 2.8442 13.2118C1.99236 12.3696 1.35979 11.3316 1.00179 10.1885C0.643789 9.04535 0.571267 7.83194 0.79056 6.65431C1.00985 5.47669 1.51429 4.37071 2.25976 3.43307C3.00523 2.49543 3.96904 1.75468 5.06692 1.27558C5.40438 1.12832 5.79732 1.2825 5.94458 1.61996Z"
              fill="#64748B"
            />
          </g>
          <defs>
            <clipPath id="clip0_2726_1566">
              <rect width="16" height="16" fill="white" />
            </clipPath>
          </defs>
        </svg>
        High Allocation Percentage
      </div>
      <div className="flex flex-row gap-1 items-center">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <g clip-path="url(#clip0_2726_688)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M7.99996 1.99996C4.68625 1.99996 1.99996 4.68625 1.99996 7.99996C1.99996 11.3137 4.68625 14 7.99996 14C11.3137 14 14 11.3137 14 7.99996C14 4.68625 11.3137 1.99996 7.99996 1.99996ZM0.666626 7.99996C0.666626 3.94987 3.94987 0.666626 7.99996 0.666626C12.05 0.666626 15.3333 3.94987 15.3333 7.99996C15.3333 12.05 12.05 15.3333 7.99996 15.3333C3.94987 15.3333 0.666626 12.05 0.666626 7.99996ZM7.99996 2.99996C8.36815 2.99996 8.66663 3.29844 8.66663 3.66663V3.99996H8.77774C10.005 3.99996 11 4.99488 11 6.22218C11 6.59037 10.7015 6.88885 10.3333 6.88885C9.9651 6.88885 9.66663 6.59037 9.66663 6.22218C9.66663 5.73126 9.26866 5.33329 8.77774 5.33329H7.33329C6.78101 5.33329 6.33329 5.78101 6.33329 6.33329C6.33329 6.88558 6.78101 7.33329 7.33329 7.33329H8.66663C9.95529 7.33329 11 8.37796 11 9.66663C11 10.9553 9.95529 12 8.66663 12V12.3333C8.66663 12.7015 8.36815 13 7.99996 13C7.63177 13 7.33329 12.7015 7.33329 12.3333V12H7.22218C5.99488 12 4.99996 11.005 4.99996 9.77774C4.99996 9.40955 5.29844 9.11107 5.66663 9.11107C6.03482 9.11107 6.33329 9.40955 6.33329 9.77774C6.33329 10.2687 6.73126 10.6666 7.22218 10.6666H8.66663C9.21891 10.6666 9.66663 10.2189 9.66663 9.66663C9.66663 9.11434 9.21891 8.66663 8.66663 8.66663H7.33329C6.04463 8.66663 4.99996 7.62196 4.99996 6.33329C4.99996 5.04463 6.04463 3.99996 7.33329 3.99996V3.66663C7.33329 3.29844 7.63177 2.99996 7.99996 2.99996Z"
              fill="#64748B"
            />
          </g>
          <defs>
            <clipPath id="clip0_2726_688">
              <rect width="16" height="16" fill="white" />
            </clipPath>
          </defs>
        </svg>
        High Income
      </div>
    </div>
  );
};

export const InsightsPageHeader = ({ segment }: { segment: string }) => {
  const history = useHistory();

  return (
    <div className="flex flex-col px-8">
      <div className="flex flex-row my-4">
        <h1 className="text-preset-2 font-bold flex flex-row gap-2 items-center">
          <button
            className="flex flex-row gap-2 items-center text-content-muted"
            onClick={() => history.push('/tools')}
          >
            <Icon type="arrow-left" className="h-4 w-4" />
            Back to Growth Products
          </button>
        </h1>
      </div>
      <div className="flex flex-col gap-6 mt-6 p-6 bg-bg-subtle border rounded-xl">
        <div className="flex flex-row justify-between">
          <div className="flex flex-col gap-1">
            <div className="flex flex-row gap-2">
              <h2 className="text-preset-4 font-bold">{segment}</h2>
              <h4 className="text-content-primary text-preset-1 bg-bg-primary--muted px-2 py-0.5 flex items-center rounded-full">
                Segment
              </h4>
            </div>
            <p className="text-preset-2 text-content-subtle">
              Export the customer list from this segment and use in your marketing
            </p>
          </div>

          <div className="flex flex-row gap-1">
            <div>
              <button className="flex flex-row gap-1 text-white text-preset-2 font-bold bg-bg-primary rounded-xl px-3.5 py-2.5">
                Export List
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M6.29164 8.29294C6.10483 8.48183 6.00006 8.73678 6.00006 9.00244C6.00006 9.2681 6.10483 9.52305 6.29164 9.71194L9.23064 12.6769C9.44864 12.8919 9.73064 12.9989 10.0096 12.9989C10.2886 12.9989 10.5656 12.8919 10.7786 12.6769L13.7086 9.72194C13.8952 9.53292 13.9998 9.27803 13.9998 9.01244C13.9998 8.74686 13.8952 8.49196 13.7086 8.30294C13.6168 8.20976 13.5074 8.13576 13.3867 8.08525C13.266 8.03474 13.1365 8.00873 13.0056 8.00873C12.8748 8.00873 12.7453 8.03474 12.6246 8.08525C12.5039 8.13576 12.3945 8.20976 12.3026 8.30294L10.0046 10.6199L7.69764 8.29294C7.6056 8.20012 7.4961 8.12644 7.37544 8.07617C7.25478 8.02589 7.12536 8 6.99464 8C6.86393 8 6.7345 8.02589 6.61384 8.07617C6.49319 8.12644 6.38368 8.20012 6.29164 8.29294Z"
                    fill="white"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>

        <IconDisplays />
      </div>
    </div>
  );
};

export const UserListPage = () => {
  const location = useLocation();
  const segment = new URLSearchParams(location.search).get('segment');

  return (
    <div className="flex flex-row w-full">
      <div className="flex-1 flex flex-col w-full">
        <InsightsPageHeader segment={segment || 'Upselling'} />

        <div className="flex flex-row flex-1">
          <div className="flex flex-col p-8 flex-1">
            <Tab.Group>
              <Tab.List className="flex flex-row gap-6 border-b">
                <Tab as={React.Fragment}>
                  {({ selected }) => (
                    <button
                      className={`text-preset-2 text-content-muted pb-4 outline-none border-b-2 ${
                        selected ? 'border-content-primary' : 'border-transparent'
                      }`}
                    >
                      All Allocations
                    </button>
                  )}
                </Tab>
                <Tab as={React.Fragment}>
                  {({ selected }) => (
                    <button
                      className={` text-preset-2 text-content-muted pb-4 outline-none border-b-2 ${
                        selected ? 'border-content-primary' : 'border-transparent'
                      }`}
                    >
                      Full Allocation
                    </button>
                  )}
                </Tab>
                <Tab as={React.Fragment}>
                  {({ selected }) => (
                    <button
                      className={` text-preset-2 text-content-muted pb-4 outline-none border-b-2 ${
                        selected ? 'border-content-primary' : 'border-transparent'
                      }`}
                    >
                      Partial Allocation
                    </button>
                  )}
                </Tab>
              </Tab.List>
            </Tab.Group>
            <UserTable />
          </div>
        </div>
      </div>
      <div className="flex-col bg-bg-subtle gap-4 p-4 border-l hidden md:flex">
        <Tab.Group>
          <Tab.List className="flex flex-row">
            <Tab as={React.Fragment}>
              {({ selected }) => (
                <button
                  className={`flex-1 text-preset-2 text-content-muted pb-4 outline-none border-b-2 ${
                    selected ? 'border-content-primary' : 'border-transparent'
                  }`}
                >
                  Strategy
                </button>
              )}
            </Tab>
            <Tab as={React.Fragment}>
              {({ selected }) => (
                <button
                  className={`flex-1 text-preset-2 text-content-muted pb-4 outline-none border-b-2 ${
                    selected ? 'border-content-primary' : 'border-transparent'
                  }`}
                >
                  Activity
                </button>
              )}
            </Tab>
          </Tab.List>
        </Tab.Group>
        <DemoCard heading="Opportunity Size" subheading="$21,357,000" />
        <DemoCard heading="Market Share" subheading="93% of users" />
        <DemoCard heading="Marketing Reccomendation" subheading="Retain these users" />
      </div>
    </div>
  );
};

const DemoCard: React.FC<{ heading: string; subheading: string }> = ({ heading, subheading }) => (
  <Card
    className="min-w-[250px]"
    heading={null}
    body={
      <div className="-mt-4 flex flex-col gap">
        <svg
          className="bg-bg-primary--muted rounded-full p-2 h-8 w-8"
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.00001 0.666626C8.3682 0.666626 8.66668 0.965103 8.66668 1.33329V1.99996H9.33334C11.1743 1.99996 12.6667 3.49234 12.6667 5.33329C12.6667 5.70148 12.3682 5.99996 12 5.99996C11.6318 5.99996 11.3333 5.70148 11.3333 5.33329C11.3333 4.22872 10.4379 3.33329 9.33334 3.33329H8.66668V7.33329H9.33334C11.1743 7.33329 12.6667 8.82568 12.6667 10.6666C12.6667 12.5076 11.1743 14 9.33334 14H8.66668V14.6666C8.66668 15.0348 8.3682 15.3333 8.00001 15.3333C7.63182 15.3333 7.33334 15.0348 7.33334 14.6666V14H6.66668C4.82573 14 3.33334 12.5076 3.33334 10.6666C3.33334 10.2984 3.63182 9.99996 4.00001 9.99996C4.3682 9.99996 4.66668 10.2984 4.66668 10.6666C4.66668 11.7712 5.56211 12.6666 6.66668 12.6666H7.33334V8.66663H6.66668C4.82573 8.66663 3.33334 7.17424 3.33334 5.33329C3.33334 3.49234 4.82573 1.99996 6.66668 1.99996H7.33334V1.33329C7.33334 0.965103 7.63182 0.666626 8.00001 0.666626ZM7.33334 3.33329H6.66668C5.56211 3.33329 4.66668 4.22872 4.66668 5.33329C4.66668 6.43786 5.56211 7.33329 6.66668 7.33329H7.33334V3.33329ZM8.66668 8.66663V12.6666H9.33334C10.4379 12.6666 11.3333 11.7712 11.3333 10.6666C11.3333 9.56206 10.4379 8.66663 9.33334 8.66663H8.66668Z"
            fill="#055DE1"
          />
        </svg>

        <div className="mt-2 text-preset-1 text-content-muted">{heading}</div>
        <div className="text-preset-3 font-bold">{subheading}</div>
      </div>
    }
  />
);
